import { createAction } from "@ngrx/store";
import { SegmentMastersModel } from "../models/segment-master.model";

export const ADD_SEGMENT_MASTERS = createAction(
  "ADD_SEGMENT_MASTERS",
  (segments: SegmentMastersModel) => segments,
);
